import React from 'react';
import warningSvg from 'assets/icons/warning.svg';
import Button, { Color, TextOverflow } from 'lib/Button';
import Modal from 'lib/Modal';

interface CampaignPlanLinkDiscardModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDiscard: () => void;
}

export const CampaignPlanLinkDiscardModal = ({
  isOpen,
  onClose,
  onDiscard,
}: CampaignPlanLinkDiscardModalProps): React.ReactElement => {
  return (
    <Modal
      dataTestId="campaign-plan-link-discard-changes-modal"
      isOpen={isOpen}
      onClose={onClose}
      icon={warningSvg}
      text="Changes to the campaign plan have not been saved."
      title="Unsaved changes"
      actionButtons={
        <>
          <Button label="Cancel" color={Color.SECONDARY} onClick={onClose} />
          <Button
            label="Discard changes"
            color={Color.DANGER}
            textOverflow={TextOverflow.VISIBLE}
            onClick={onDiscard}
          />
        </>
      }
    />
  );
};
